module.exports = __webpack_public_path__ + "static/media/matthew.21d2a8b6.jpg";